import { render } from "./ShowMandehNew.vue?vue&type=template&id=e77dedb0"
import script from "./ShowMandehNew.vue?vue&type=script&lang=js"
export * from "./ShowMandehNew.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__